/**
 * Get Completed Deliveries Use Case
 *
 * This use case handles the business logic for filtering completed deliveries.
 * It follows Single Responsibility Principle by handling only completed deliveries logic.
 *
 * @module GetCompletedDeliveriesUseCase
 */

import {DistributionRecord, DistributionStatus} from '../models/distribution.model';

export class GetCompletedDeliveriesUseCase {
  /**
   * Execute the use case to get completed deliveries
   * @param records - Array of distribution records
   * @returns Array of completed delivery records
   */
  execute (records: DistributionRecord[]): DistributionRecord[] {
    return records.filter(record =>
      record.status === DistributionStatus.DELIVERED
    );
  }
}

